import { CssBaseline, GlobalStyles, ThemeProvider, Typography } from '@mui/material';
import { Provider } from 'react-redux';

import { store } from 'v3/data/store';
import { MainRoutes } from 'v3/routes';
import { LoadingGlobal } from 'v3/shared/components/Loading/DefaultLoading';
import { IndexStyles } from 'v3/styles/app-styles';
import { globalStyle, theme } from 'v3/styles/global-styles';

export const AppVersionV3 = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyle} />
        <LoadingGlobal />
        <Typography component={'div'}>
          <IndexStyles>
            <MainRoutes />
          </IndexStyles>
        </Typography>
      </ThemeProvider>
    </Provider>
  );
};

export default AppVersionV3;
